import { alertConstants } from "../_constants";

export const alertActions = {
  success,
  error,
  loading,
  clear,
  cancel,
};

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function loading(message) {
  return { type: alertConstants.LOADING, message };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function clear(messages) {
  return { type: alertConstants.CLEAR, messages };
}

function cancel() {
  return { type: alertConstants.CANCEL };
}
